import * as xlsx from "xlsx";

import constants from "../../config/constants";

const $inject = [
  "$q",
  "$location",
  "$scope",
  "$timeout",
  "$routeParams",
  "$http",
  "dataService",
  "dataSourceService",
  "microApiService",
];

const lbaGridCtrl = function (
  $q,
  $location,
  $scope,
  $timeout,
  $routeParams,
  $http,
  dataService,
  dataSourceService,
  microApiService
) {
  const vm = this;

  vm.dataService = dataService;
  vm.ready = false;
  vm.canAdd = vm.settings.hasOwnProperty("gridAdd");
  vm.filters = '';
  vm.filterObj = {
    text: '',
    key: '',
  }

  vm.handleFilterChange = function () {
    let keys = {};
    vm.filters = vm.filterObj.key.length > 0 ? _.set(keys, vm.filterObj.key, vm.filterObj.text) : vm.filterObj.text;
  };
  
  vm.onClick = onClick;
  vm.addNew = addNew;
  vm.getObjectPropertyValue = getObjectPropertyValue;
  vm.exportExcel = exportExcel;
  vm.importExcel = importExcel;
  vm.showImportSuccessful = false;
  vm.showImportFailed = false;

  function processMicroService(res) {
    vm.dataService.data.items = res.data;

    vm.resource = {
      header: vm.settings.gridCols,
      rows: vm.dataService.data.items,
      pagination: {
        page: 1,
      },
    };

    vm.ready = true;
  }

  function init() {
    const dataLookUp = !vm.results
      ? dataService.spiltDataAt(vm.settings.dataAt, $routeParams)
      : null;

    const rowData =
      vm.results || prepData(_.get(dataService.data.activeItem, dataLookUp));

    vm.resource = {
      header: vm.settings.gridCols,
      rows: rowData,
      pagination: {
        page: 1,
      },
    };

    vm.ready = true;

    $timeout(function () {
      $scope.$apply();
    }, 0);
  }

  if (vm.settings.microService) {
    dataService.data.activeItem = undefined;
    dataSourceService.dataSource = constants.DATA_SOURCES.AUTH_ZERO;
    microApiService.get({
      endpoint: vm.settings.endpoint,
      cb: processMicroService,
    });
  } else {
    if (vm.settings.endpoint) {
      dataSourceService.dataSource = constants.DATA_SOURCES.ODATA;
      dataService.data.activeItem = undefined;
      const ODataArgs = vm.settings.ODataArgs || "";
      dataService.get(vm.settings.endpoint + ODataArgs).then((data) => {
        data = data.map((item) => {
          vm.settings.gridCols.forEach((col) => {
            let dataCheck = _.get(item, col.key);
            if (!dataCheck) {
              _.set(item, col.key, "-");
            }
          });
          return item;
        });

        vm.dataService.data.items = data;

        vm.resource = {
          header: vm.settings.gridCols,
          rows: vm.dataService.data.items,
          pagination: {
            page: 1,
          },
        };

        vm.ready = true;
      });
    } else {
      init();
    }
  }

  function onClick(data, copyItem, copyResource, cloneResource) {
    dataService.backPath = $location.$$path;

    if (copyItem) {
      vm.ready = false;

      $timeout(() => {
        const clonedData = angular.copy(data);
        delete clonedData.Id;
        if (!(clonedData[vm.settings.gridCols[0].key] instanceof Array)) {
          clonedData[vm.settings.gridCols[0].key] += " COPY";
        }
        vm.resource.rows.push(clonedData);
        const dataLookUp = dataService.spiltDataAt(
          vm.settings.dataAt,
          $routeParams
        );
        const activeItem = prepData(
          _.get(dataService.data.activeItem, dataLookUp)
        );
        activeItem.push(clonedData);
        _.set(dataService.data.activeItem, dataLookUp, activeItem);
        vm.copyMode = false;
        vm.ready = true;
      }, 0);

      return;
    }

    if (copyResource) {
      dataService.get(vm.settings.endpoint, data.Id).then((data) => {
        const duplicate = data;
        duplicate.Name = duplicate.Name + " COPY";
        delete duplicate.Id;

        vm.dataService
          .post(vm.settings.endpoint, duplicate, true)
          .then((data) => {
            updatePath(data);
          });
      });

      return;
    }

    if (cloneResource) {
      var promptTitle = vm.settings.canCloneResourceInputMessage ? vm.settings.canCloneResourceInputMessage : "Enter new resource name?";
      const name = window.prompt(promptTitle);
      if (name === null) return;
      if (_.isEmpty(name)) {
        alert(`${promptTitle} cannot be null or empty`);
      } else {
        dataService.get(`${vm.settings.endpoint}?$filter=Name eq '${name}'&$top=1`)
          .then((dataObj) => {
            if (!_.isEmpty(dataObj)) {
              throw Error(`Cloning failed: '${name}' already exists, please enter new name.`);
            }
            return dataService.get(vm.settings.endpoint, data.Id);
          })
          .then((dataObj) => {
            const duplicate = dataObj;
            duplicate.Name = name;
            delete duplicate.Id;
            return vm.dataService.post(vm.settings.endpoint, duplicate, true);
          })
          .then((dataObj) => {
            updatePath(dataObj);
          })
          .catch((error) => {
            alert(error);
            return;
          });
      }
      return;
    }

    const itemIndex = vm.resource.rows.findIndex(i => {
      return JSON.stringify(i) === JSON.stringify(data);
    });

    updatePath(data, itemIndex);
  }

  function addNew() {
    dataService.backPath = $location.$$path;
    if (vm.settings.gridAdd) {
      $location.path($location.$$path + "/add");
    } else {
      dataService.addNewMode = true;
      dataService.addNewBackup = angular.copy(dataService.data.activeItem);

      if (vm.resource.rows) {
        vm.resource.rows.push({});
      } else {
        vm.resource.rows = [{}];
      }
      updatePath({}, vm.resource.rows.length - 1);
    }
  }

  function updatePath(data, index) {    
    const displayNamePathReady = vm.settings.displayName
      .replace(/\s+/g, "-")
      .toLowerCase();
    
    const appendToPath = vm.settings.gridAdd || vm.settings.useIdForRouting
      ? data.Id
      : displayNamePathReady + "/" + index;
    $location.path($location.$$path + "/" + appendToPath);
  }

  function prepData(data) {
    if (data) {
      return data.map((item) => {
        return item;
      });
    }
  }

  function getObjectPropertyValue(obj, path, defaultValue = null) {
    let val = _.get(obj, path, defaultValue);

    if (val && Array.isArray(val)) {
      if (val[0] && _.isObject(val[0])) {
        val = val
          .map((i) => {
            return i.Title ? i.Title : false;
          })
          .join(", ");
      } else {
        val = val.join(", ");
      }
    }

    return val === false ? "false" : val;
  }

  function importExcel(file) {
    var reader = new FileReader();
    let output = [];

    reader.onload = function (e) {
      try {
        var data = e.target.result;
        var wb = xlsx.read(data, {
          type: "binary",
        });

        wb.SheetNames.forEach((sheetName) => {
          if (sheetName === vm.settings.excelExport.fileName) {
            output = xlsx.utils
              .sheet_to_json(wb.Sheets[sheetName])
              .map((item) => {
                const obj = {};
                vm.settings.excelExport.cols.forEach((col) => {
                  if (col.commaSeparateArray && item[col.name] && item[col.name].length > 0) {
                    item[col.name] = item[col.name].split(',');
                  }
                  if (col.isArray && !item[col.name]) {
                    _.set(obj, col.dataAt, item[col.name] || []);
                  } else if (col.isBoolean) {
                    _.set(obj, col.dataAt, item[col.name] || false);
                  } else {
                    _.set(obj, col.dataAt, item[col.name] || null);
                  }
                });

                return obj;
              });
          }
        });

        wb.SheetNames.forEach((sheetName) => {
          if (sheetName !== vm.settings.excelExport.fileName) {
            let sheet = xlsx.utils.sheet_to_json(wb.Sheets[sheetName]);

            const key = vm.settings.excelExport.cols.find((col) => {
              return col.name === sheetName;
            }).dataAt;

            sheet.forEach((row) => {
              if (row[sheetName]) {
                const data = "" + row[sheetName];

                if (output[row.id - 1][key]) {
                  output[row.id - 1][key].push(data);
                } else {
                  output[row.id - 1][key] = [data];
                }
              }
            });
          }
        });

        const dataLookUp = dataService.spiltDataAt(
          vm.settings.dataAt,
          $routeParams
        );
        _.set(dataService.data.activeItem, dataLookUp, output);
        vm.showImportSuccessful = true;
      } catch (e) {
        console.warn(e);
        vm.showImportFailed = true;
      }

      init();
    };

    reader.onerror = function (ex) {
      console.warn(ex);
    };

    reader.readAsBinaryString(file);
  }

  let ExcelData = [];
  let colWidths = [];
  let additionalSheets = {};
  let asyncData = undefined;
  let ids = [];

  function exportExcel() {
    if (!vm.settings.excelExport) return;
    if (!vm.settings.excelExport.asyncLookup) return buildExcelFile();

    vm.resource.rows.forEach((row, i) => {
      vm.settings.excelExport.cols.forEach((col) => {
        if (vm.settings.excelExport.asyncLookup.dataAt.includes(col.dataAt)) {
          ids = ids.concat(_.get(row, col.dataAt));
        }
      });
    });

    ids = _.uniq(ids);

    $http
      .post(`${endPointUrl}/api/v2/Hotels/GetProviderHotelsByExternalIds`, {
        ExternalIds: ids,
      })
      .then((res) => {
        asyncData = res.data.Result;
        buildExcelFile();
      });
  }

  function buildExcelFile() {
    ExcelData = [];

    vm.resource.rows.forEach((row, i) => {
      const dataItem = vm.settings.excelExport.excludeGeneratedId ? {} : { id: i + 1 };

      vm.settings.excelExport.cols.forEach((col) => {
        let colData = _.get(row, col.dataAt);

        let ArrayParent = vm.settings.excelExport.arrayParentRef;

        if (col.isArray) {
          const additionalSheet = [];

          colData.forEach((value) => {
            additionalSheet.push(
              vm.settings.excelExport.excludeGeneratedId ? 
                { [ArrayParent.name]: row[ArrayParent.dataAt], [col.name]: value } : 
                { id: i + 1, [ArrayParent.name]: row[ArrayParent.dataAt], [col.name]: value }
            );
          });

          if (additionalSheets[col.name]) {
            additionalSheets[col.name] = additionalSheets[col.name].concat(
              additionalSheet
            );
          } else {
            additionalSheets[col.name] = additionalSheet;
          }

          if (col.asyncId) {
            additionalSheets[col.name] = additionalSheets[col.name].map(
              (item) => {
                let asyncVal = asyncData.find(val => val[col.asyncId] === item[col.name]);

                if (asyncVal) {
                  item[col.asyncColName] = asyncVal[col.asyncKey];
                }

                return item;
              }
            );
          }
        } else {
          colWidths.push({ width: 25 });
          dataItem[col.name] = col.commaSeparateArray ? colData.toString() : colData;
        }
      });

      ExcelData.push(dataItem);
    });

    finalizeExport();
  }

  function finalizeExport() {
    try {
      if (ExcelData && ExcelData.length > 0) {
        const ws = xlsx.utils.json_to_sheet(ExcelData);
        ws["!cols"] = [...Array(Object.keys(ExcelData[0]).length)].map(() => {
          return { width: 25 };
        });
        const wb = xlsx.utils.book_new();

        xlsx.utils.book_append_sheet(wb, ws, vm.settings.excelExport.fileName);

        Object.keys(additionalSheets).forEach((key) => {
          const additionalWs = xlsx.utils.json_to_sheet(additionalSheets[key], {
            header: ["id", vm.settings.excelExport.arrayParentRef.name, key],
          });
          additionalWs["!cols"] = [...Array(4)].map(() => {
            return { width: 25 };
          });
          xlsx.utils.book_append_sheet(wb, additionalWs, key);
        });

        xlsx.writeFile(
          wb,
          `${vm.settings.excelExport.fileName.replace(" ", "-")}.xlsx`
        );
      }
    } catch (e) {
      console.log("export error", e);
    }
  }
};

lbaGridCtrl.$inject = $inject;

export default lbaGridCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaGrid/lbaGridCtrl.js